import { postMultipart } from '../../graphql/restClient';
import type { Asset } from '../../types/forge';

/**
 * Upload a file to platform-service /assets and return the inserted
 * Asset row. The server enforces the JWT and writes the row into
 * Hasura (which RLS-scopes by org), so we don't pass org_id from here.
 */
export async function uploadAsset(args: {
  file: File;
  kind: 'image' | 'icon' | 'splash';
  name?: string;
}): Promise<Asset> {
  const fd = new FormData();
  fd.append('file', args.file);
  fd.append('kind', args.kind);
  if (args.name) fd.append('name', args.name);
  return postMultipart<Asset>('/assets', fd);
}
